export enum Path {
  Blank = '',
  Root = '/',
  Home = 'home',
  Bicycles = 'bicycles',
  AdditionalGear = 'additional-gear',
  CyclingPaths = 'cycling-paths',
  CyclingTours = 'cycling-tours',
  GPSLink = 'gps-link',
  AccountManagement = 'account-management',
  WildCard = '**',
  Login = 'login',
  Logout = 'logout',
  Pedals = 'pedals',
  BikeCategories = 'bike-categories',
  ReservationDuration = 'reservation-duration',
  VAT = 'vat',
  WorkingHours = 'working-hours',
  RentalDuration = 'rental-duration',
  PriceList = 'price-list',
  RentalDurationSunbeds = 'rental-duration-sunbeds',
  ReservationDurationSunbeds = 'reservation-duration-sunbeds',
  MicroLocations = 'micro-locations',
  Zones = 'zones',
  AllPaymentFooters = 'payment-footer',
  SunbedTypes = 'sunbed-types',
  PriceListSunbeds = 'price-list-sunbeds',
  GearPriceList = 'gear-price-list',
  DocumentTypes = 'document-types',
  RentalNote = 'rental-note',
  SearchEngineOptimization = 'search-engine-optimization',
  ArticleList = 'articles',
  ArticleCategories = 'article-categories',
  ArticlePrices = 'article-prices',
}
